import * as types from './actionTypes';

export const joinMeeting = status => {
  return {
    type: types.JOIN_MEETING,
    payload: status,
  };
};

export const setAvatarURL = url => {
  return {
    type: types.SET_AVATAR_URL,
    payload: url,
  };
};

export const setDirectLanding = land => {
  return {
    type: types.SET_DIRECT_LANDING,
    payload: land,
  };
};

export const setReadyToMove = (ready_to_move = false) => {
  return {
    type: types.SET_READY_TO_MOVE,
    payload: ready_to_move,
  };
};

export const setCustomCourse = customCourse => {
  return {
    type: types.SET_CUSTOM_COURSE,
    payload: customCourse,
  };
};

export const setShowConfirmationDialog = show => {
  return {
    type: types.SET_SHOW_LEAVE_CONFIRMATION_MODAL,
    payload: show,
  };
};

export const setCourseLeaveConfigs = configs => {
  return {
    type: types.SET_COURSE_LEAVE_CONFIGS,
    payload: configs,
  };
};

export const setLegacyFlag = legacy => {
  return {
    type: types.SET_LEGACY_FLAG,
    payload: legacy,
  };
};

export const setIsQuikbase = isQuikbase => {
  return {
    type: types.SET_IS_QUIKBASE,
    payload: isQuikbase,
  };
};

// ----- Lesson transcript/panel controls (Unity-driven) -----

export const setLessonButtonVisibility = ({buttonType, visible}) => {
  return {
    type: types.SET_LESSON_BUTTON_VISIBILITY,
    payload: {buttonType, visible},
  };
};

export const setLessonButtonInteraction = ({buttonType, interactable}) => {
  return {
    type: types.SET_LESSON_BUTTON_INTERACTION,
    payload: {buttonType, interactable},
  };
};

// Reset all lesson button interactions (next/previous/pause/resume) to disabled.
// Unity is the only source of truth for re-enabling them via set_lesson_button_interaction.
export const resetLessonButtonInteraction = () => {
  return {
    type: types.RESET_LESSON_BUTTON_INTERACTION,
  };
};

export const setLessonPieceText = ({text, lessonId} = {}) => {
  return {
    type: types.SET_LESSON_PIECE_TEXT,
    payload: {text, lessonId},
  };
};

// Flag that a lesson has been started via start_lesson command
export const setLessonStarted = started => {
  return {
    type: types.SET_LESSON_STARTED,
    payload: started,
  };
};

// Flag that Unity has sent rpmReady for the current world/avatar
export const setRpmReady = ready => {
  return {
    type: types.SET_RPM_READY,
    payload: ready,
  };
};

// Flag that lesson is paused (true = paused, false = playing)
export const setLessonPaused = paused => {
  return {
    type: types.SET_LESSON_PAUSED,
    payload: paused,
  };
};
